import PropTypes from 'prop-types';
import { withTranslation } from 'utils/with-i18next';
import { useInView } from 'lib/useInView';

const ShowcaseSection = ({ t }) => {
  const [ref, isInView] = useInView({ threshold: 0.3 });

  return (
    <section className="py-20 mt-16 bg-gradient-to-b from-gray-900/50 to-background overflow-hidden relative" ref={ref}>
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-primary/5" />

      <div className={`relative w-full overflow-hidden ${isInView ? 'animate-fade-in' : 'opacity-0'}`}>
        <div className="flex whitespace-nowrap">
          <div className="animate-marquee flex shrink-0">
            <span className="inline-block px-8 text-4xl md:text-6xl font-bold bg-gradient-to-r from-primary/40 via-primary/20 to-primary/40 bg-clip-text text-transparent uppercase tracking-wider">
              {t('bottom-slide-desc')}
            </span>
            <span className="inline-block px-8 text-4xl md:text-6xl font-bold bg-gradient-to-r from-primary/40 via-primary/20 to-primary/40 bg-clip-text text-transparent uppercase tracking-wider">
              {t('bottom-slide-desc')}
            </span>
            <span className="inline-block px-8 text-4xl md:text-6xl font-bold bg-gradient-to-r from-primary/40 via-primary/20 to-primary/40 bg-clip-text text-transparent uppercase tracking-wider">
              {t('bottom-slide-desc')}
            </span>
          </div>
          <div className="animate-marquee flex shrink-0" aria-hidden="true">
            <span className="inline-block px-8 text-4xl md:text-6xl font-bold bg-gradient-to-r from-primary/40 via-primary/20 to-primary/40 bg-clip-text text-transparent uppercase tracking-wider">
              {t('bottom-slide-desc')}
            </span>
            <span className="inline-block px-8 text-4xl md:text-6xl font-bold bg-gradient-to-r from-primary/40 via-primary/20 to-primary/40 bg-clip-text text-transparent uppercase tracking-wider">
              {t('bottom-slide-desc')}
            </span>
            <span className="inline-block px-8 text-4xl md:text-6xl font-bold bg-gradient-to-r from-primary/40 via-primary/20 to-primary/40 bg-clip-text text-transparent uppercase tracking-wider">
              {t('bottom-slide-desc')}
            </span>
          </div>
        </div>
      </div>
  </section>
  );
};

ShowcaseSection.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('index')(ShowcaseSection);
